import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import MomentCard from "@/components/MomentCard";

// Every standout line the Coach has picked, ready to reshare as a card.
export default function MomentsGallery({ empty = "When your Coach says something worth keeping, it'll be saved here." }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/moments/mine").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  if (!rows.length) return <p className="text-sm text-muted-foreground" data-testid="moments-gallery-empty">{empty}</p>;
  return (
    <div className="grid gap-3" data-testid="moments-gallery">
      {rows.map((m) => <MomentCard key={m.quote} quote={m.quote} shared={m.shared} />)}
    </div>
  );
}
